"use strict";

var rHyphen = /-(.)/g;

module.exports = function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/react-widgets/~/dom-helpers/util/camelize.js
// module id = 647
// module chunks = 0